import PlaylistAssignmentsTablePage from './PlaylistAssignmentsTablePage';
import PlaylistAssignmentsPortalsTable from './PlaylistAssignmentsPortalsTable';
import PlaylistAssignmentsPortalsList from './PlaylistAssignmentsPortalsList';
import PlaylistAssignmentsBlankPage from './PlaylistAssignmentsBlankPage';
import PlaylistAssignmentsForPortal from './PlaylistAssignmentsForPortal';
import { useFilteredPlaylistAssignmentsPortals, usePlaylistAssignmentsParams } from '../playlistAssignmentsHooks';
import { useFilteredContentAssignmentsPortals } from '../contentAssignmentsHooks';
import { getPlaylistAssignmentsUrl } from '../playlistAssignmentsUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { AssignPlaylistButton } from 'academy-common-lib/features/playlistAssignments/components/AssignPlaylistButton';
import { ContentAssignButton } from 'academy-common-lib/features/contentAssignments/components/ContentAssignButton';
import { usePlaylist } from '../../savedItems/savedItemsQueries.migrated';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaylistAssignmentsPortalsCount = ({
  count,
  total
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.playlistAssignments.portalsCount`,
    options: {
      count,
      total
    }
  });
};
const PlaylistAssignmentsPortals = ({
  playlistId: propPlaylistId,
  contentType
}) => {
  var _contentResult$conten;
  const {
    isMobile
  } = useMediaQuery();
  const {
    playlistId: paramPlaylistId
  } = usePlaylistAssignmentsParams();
  const playlistId = propPlaylistId || paramPlaylistId;
  const navigate = useACNavigate();
  const useContentFlow = !!contentType;
  const {
    playlist
  } = usePlaylist(playlistId || 0, !playlistId);
  const playlistName = (playlist === null || playlist === void 0 ? void 0 : playlist.name) || '';
  const playlistResult = useFilteredPlaylistAssignmentsPortals({
    playlistId,
    skip: useContentFlow
  });
  const contentResult = useFilteredContentAssignmentsPortals({
    contentId: playlistId || 0,
    contentType: contentType || 'PLAYLIST',
    skip: !useContentFlow
  });
  const total = useContentFlow ? contentResult.total : playlistResult.total;
  const loading = useContentFlow ? contentResult.contentAssignmentsPortalsLoading : playlistResult.playlistAssignmentsPortalsLoading;
  const query = useContentFlow ? contentResult.query : playlistResult.query;
  const portals = useContentFlow ? (_contentResult$conten = contentResult.contentAssignmentsPortals) === null || _contentResult$conten === void 0 ? void 0 : _contentResult$conten.map(p => Object.assign({}, p, {
    playlistId: p.contentId
  })) : playlistResult.playlistAssignmentsPortals;
  if (!playlistId || loading) return null;
  if (!total && !(query !== null && query !== void 0 && query.length)) return /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPage, {
    contentName: useContentFlow ? playlistName : undefined,
    contentType: contentType,
    playlistId: playlistId
  });
  if (total === 1 && portals && portals.length && !(query !== null && query !== void 0 && query.length)) return /*#__PURE__*/_jsx(PlaylistAssignmentsForPortal, {
    contentType: contentType,
    playlistId: playlistId,
    portalId: portals[0].portal.id
  });
  const handleOnRowOpenChange = portalId => navigate(getPlaylistAssignmentsUrl(playlistId, portalId));
  return /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
    actions: /*#__PURE__*/_jsx(Flex, {
      overflow: "visible",
      children: useContentFlow ? /*#__PURE__*/_jsx(ContentAssignButton, {
        contentId: playlistId,
        contentName: playlistName,
        contentType: contentType
      }) : /*#__PURE__*/_jsx(AssignPlaylistButton, {
        playlistId: playlistId
      })
    }),
    headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.portalsHeader"
    }),
    searchFilter: FILTER_TYPES.SEARCH_ACCOUNTS,
    tableCount: portals && total !== undefined && /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsCount, {
      count: portals.length,
      total: total
    }),
    children: isMobile ? /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsList, {
      contentName: useContentFlow ? playlistName : undefined,
      contentType: contentType,
      onRowClick: ({
        portal: {
          portal: {
            id
          }
        }
      }) => handleOnRowOpenChange(id),
      playlistId: playlistId
    }) : /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTable, {
      contentType: contentType,
      playlistId: playlistId
    })
  });
};
export default PlaylistAssignmentsPortals;